import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { BaseObject } from '../../../core/business-objects/base-object/base-object.model';
import { BaseObjectStoreFacade } from '../../../core/business-objects/base-object/base-object.store-facade';
import { VasAppFacade } from '../../services/vas-app-facade.service';
import * as fromRoot from '../../store/bootstrap';

export abstract class VasBaseObjectStoreFacade<T  extends BaseObject> extends BaseObjectStoreFacade<T> {

    constructor(protected appFacade: VasAppFacade, protected storeService: Store<fromRoot.State>, protected entityName: string) {
        super(appFacade, storeService);
    }

    protected getEntity(): string {
        return this.entityName;
    }

    getFilters(): Observable<fromRoot.BaseObjectFilters> {
        return this.storeService.select(state => state[this.entityName].filters);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/base-object/vas-base-object-store.facade.ts